import React from 'react';
import { Website } from '../website.js';

const directionsApi = "https://www.google.com/maps/dir/?api=1&destination=";

function ClosestDealersEntry({translations, dealer, onDealerClick}) {
    var directionsUrl =
        directionsApi + dealer.Street + "+" + dealer.ZipCode;
    return (
        <div className="dealerEntry">
            <h4><a onClick={(event) => onDealerClick(dealer, true, event)} >{dealer.Name}</a></h4>
            <a href={directionsUrl} target="_blank" className="directions-link"><span className="icon-directions_car"></span><span className="directions-text">{translations.googleMaps}</span></a>
            <p>{dealer.Street}, {dealer.ZipCode} {dealer.City}</p>
            <Website webaddress={dealer.Web} target={"_blank"} icon={true} />
        </div>
        );
}

export {ClosestDealersEntry};